import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { commonThemeBackgroundClass } from '../../../core/utilities/color';

@Component({
    selector: 'app-row-separator',
    template: '',
    styleUrls: ['./row-separator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RowSeparatorComponent {

  @HostBinding('class')
  protected get classes(): string {
    return commonThemeBackgroundClass('foreground');
  }

}
